var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLandingTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "twi_red copy",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.4119C1.6344 13.4155 3.5748 14 5.661 14C12.4542 14 16.1685 8.6135 16.1685 3.94275C16.1685 3.78962 16.1649 3.63825 16.1577 3.48688C16.8795 2.98813 17.5059 2.366 18 1.65725C17.3385 1.939 16.6266 2.128 15.8796 2.212C16.6419 1.77712 17.226 1.08238 17.5032 0.258125C16.7895 0.662375 15.9984 0.956375 15.1578 1.11475C14.4846 0.42875 13.5243 0 12.4623 0C10.4229 0 8.7687 1.58113 8.7687 3.53238C8.7687 3.81063 8.802 4.07925 8.865 4.33825C5.796 4.19125 3.0735 2.78425 1.2537 0.64575C0.936 1.169 0.7533 1.7745 0.7533 2.42287C0.7533 3.64875 1.4049 4.73112 2.3958 5.36462C1.7901 5.348 1.2213 5.18787 0.7227 4.92275C0.7227 4.93762 0.7227 4.9525 0.7227 4.96737C0.7227 6.67887 1.9971 8.10863 3.6846 8.43325C3.3759 8.51463 3.0492 8.55663 2.7126 8.55663C2.4741 8.55663 2.2428 8.53562 2.0178 8.49362C2.4867 9.89888 3.8511 10.9209 5.4666 10.948C4.203 11.8965 2.6127 12.46 0.8811 12.46C0.5832 12.46 0.2898 12.446 0 12.4119Z",
    fill: "#AFC0D1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingTwitter);
export default __webpack_public_path__ + "static/media/landingTwitter.2c5da0e55b574970c611457c3ea884df.svg";
export { ForwardRef as ReactComponent };